import { Grid, TextField } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, InlineTextButton, TypographyWrapper } from '../../components';
import { validateVoucher, VoucherifyState } from '../../ducks/voucherify.duck';
import { useAppDispatch } from '../../hooks/appDispatch';
import { RequestStatus } from '../../types/requestStatus';
import { handle } from '../../util/helpers';
import { CheckoutPageState, fetchOrderLineItems, setVoucher } from './CheckoutPage.duck';
import css from './DiscountCodeInput.module.css';
import { TypographyFormat } from '../../components/TypographyWrapper/TypographyWrapper';
import { useShopConfig } from '../../hooks/shopConfig';

const DiscountCodeInput: FC = () => {
  const dispatch = useAppDispatch();
  const { css: brandCss } = useShopConfig();
  const backgroundColor = brandCss?.backgroundColor;

  const { fetchLineItemsStatus } = useSelector<any>(
    (state) => state.CheckoutPage
  ) as CheckoutPageState;
  const { validateVoucherStatus } = useSelector<any>(
    (state) => state.voucherify
  ) as VoucherifyState;

  const [shouldShowInput, setShouldShowInput] = useState<boolean>(false);
  const [discountCodeError, setDiscountCodeError] = useState<string | undefined>(undefined);
  const [inputDiscountCode, setInputDiscountCode] = useState<string>('');

  const onApplyDiscountCode = async (values: { discountCode?: string }) => {
    const { discountCode } = values;
    if (!discountCode) return;

    const [voucherResponse, voucherError] = await handle(dispatch(validateVoucher(discountCode)));
    await dispatch(setVoucher(voucherResponse));

    if (voucherError) {
      setDiscountCodeError('This discount code is not valid.');
    } else {
      setDiscountCodeError(undefined);
    }
    dispatch(fetchOrderLineItems());
  };

  if (!shouldShowInput) {
    return (
      <InlineTextButton
        onClick={() => setShouldShowInput(true)}
        style={{ width: '100%', backgroundColor }}
      >
        <h5 className={css.addLink}>
          <TypographyWrapper variant="body2" format={TypographyFormat.Underlined}>
            Add a discount code
          </TypographyWrapper>
        </h5>
      </InlineTextButton>
    );
  }

  const isDiscountApplicationLoading = validateVoucherStatus === RequestStatus.Pending;
  const shouldDisableApplication =
    isDiscountApplicationLoading || fetchLineItemsStatus !== RequestStatus.Success;

  const handleApplyClick = () => {
    onApplyDiscountCode({ discountCode: inputDiscountCode });
  };

  return (
    <Grid
      className={css.discountCodeWrapper}
      container
      direction="row"
      alignItems="center"
      style={{ backgroundColor }}
      spacing={2}
    >
      <Grid item xs={9}>
        <TextField
          id="discountCode"
          name="discountCode"
          placeholder="TREET20OFF"
          label="Discount Code"
          value={inputDiscountCode}
          onChange={(e) => setInputDiscountCode(e.target.value)}
          error={!!discountCodeError}
          helperText={discountCodeError}
          variant="outlined"
          size="small"
          fullWidth
        />
      </Grid>
      <Grid item xs={3} className={css.applyButtonWrapper}>
        <Button
          type="button"
          onClick={handleApplyClick}
          inProgress={isDiscountApplicationLoading}
          disabled={shouldDisableApplication || !inputDiscountCode.trim()}
          className={css.applyButton}
        >
          Apply
        </Button>
      </Grid>
    </Grid>
  );
};

export default DiscountCodeInput;
